fragment segmentDetails on SegmentType {
  id
  index
  words
}
